import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CTABannerProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
}
export function CTABanner({
  title = 'Ready to Transform Your Business?',
  subtitle = 'Partner with Invigo Technology for end-to-end ICT solutions that drive growth and efficiency.',
  buttonText = 'Start Your Project',
  buttonLink = '/contact'
}: CTABannerProps) {
  return <section className="py-20 relative overflow-hidden bg-navy-900" data-id="element-25">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-26">
        <div className="absolute -top-[50%] -right-[10%] w-[70%] h-[150%] rounded-full bg-tech-blue/10 blur-3xl" data-id="element-27" />
        <div className="absolute -bottom-[50%] -left-[10%] w-[70%] h-[150%] rounded-full bg-tech-green/10 blur-3xl" data-id="element-28" />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10 text-center" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="glass-card rounded-3xl p-10 md:p-16 max-w-4xl mx-auto" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-31">
            {title}
          </h2>
          <p className="text-lg text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-32">
            {subtitle}
          </p>
          <Link to={buttonLink} className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-tech-green rounded-full hover:bg-emerald-400 transition-all duration-300 shadow-[0_0_20px_rgba(16,185,129,0.4)] hover:shadow-[0_0_30px_rgba(16,185,129,0.6)] hover:-translate-y-1 group" data-id="element-33">
            {buttonText}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-34" />
          </Link>
        </motion.div>
      </div>
    </section>;
}